class productQuantity extends HTMLElement {
    private changeEvent: Event;
    private input: HTMLInputElement | null;

    constructor() {
      super();

      this.input = this.querySelector("input[name='quantity']");
      this.changeEvent = new Event('change', { bubbles: true });
      this.bindEvents();
    }

    bindEvents() { 
        this.input?.addEventListener("change", this.onQuantityChange.bind(this));

        const prevButton = this.querySelector("button[name='minus']");
        const nextButton = this.querySelector("button[name='plus']");

        prevButton?.addEventListener("click", this.onButtonClick.bind(this));
        nextButton?.addEventListener("click", this.onButtonClick.bind(this));
    }

    onQuantityChange(event: Event) {
        const target = event.currentTarget as HTMLInputElement;
        const quantity = target.value;
        const inputs = document.querySelectorAll("product-quantity input[name='quantity']");
        inputs.forEach((input: any) => {
            input?.setAttribute("value", quantity);
            input.value = quantity;
        })

        this.removeErrorMessage();
    }

    onButtonClick(event: Event) {
        const target: any = event.target;
        event.preventDefault();
        const previousValue = this.input?.value;

        if (target.name === 'plus') {
            this.input?.stepUp();
        }
        else {
            this.input?.stepDown();
        }

        if (previousValue !== this.input?.value) this.input?.dispatchEvent(this.changeEvent);
    }

    removeErrorMessage() {
        const errorWrappers = document.querySelectorAll(".product-form__error-message-wrapper");
        const errorMessages = document.querySelectorAll(".product-form__error-message");

        errorWrappers.forEach((errorWrapper: any) => {
            errorWrapper.classList.add("hidden");
        })       

        errorMessages.forEach((errorMessage: any) => {
            errorMessage.innerHTML = "";
        })
    }
}
  
customElements.define('product-quantity', productQuantity);